import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "./AuthProvider.js";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === "loading") {
    return <div className="flex min-h-dvh items-center justify-center text-charcoal">Loading…</div>;
  }
  if (status === "signed-out") return <Navigate to="/sign-in" replace />;
  return <>{children}</>;
}
